import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { crm, setToken } from "../lib/crmClient";

export default function CrmLogin() {
    const nav = useNavigate();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSubmitting(true);
        try {
            const { data } = await crm.post("/auth/login", { email, password });
            setToken(data.token);
            nav("/crm");
        } catch (err) {
            const d = err?.response?.data?.detail;
            setError(typeof d === "string" ? d : "Login failed — try again.");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <div
            data-testid="crm-login"
            className="min-h-screen bg-black text-white flex items-center justify-center px-6"
        >
            <form
                onSubmit={onSubmit}
                className="w-full max-w-md glass border border-white/15 p-8 md:p-10"
            >
                <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#FFE600]">
                    PaintKing · CRM
                </div>
                <h1 className="font-display uppercase text-4xl md:text-5xl leading-[0.9] tracking-tight mt-3">
                    Sign in.
                </h1>
                <p className="font-mono text-[12px] text-white/60 mt-3">
                    Admins only. Rest of the wall lives at paintking.com.
                </p>

                <div className="mt-8 space-y-4">
                    <input
                        data-testid="login-email"
                        type="email"
                        required
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        className="w-full bg-black/40 border border-white/20 focus:border-[#FFE600] focus:outline-none px-4 py-3 font-mono text-[13px] tracking-wide text-white placeholder-white/30"
                    />
                    <input
                        data-testid="login-password"
                        type="password"
                        required
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        className="w-full bg-black/40 border border-white/20 focus:border-[#FFE600] focus:outline-none px-4 py-3 font-mono text-[13px] tracking-wide text-white placeholder-white/30"
                    />
                    {error && (
                        <div
                            data-testid="login-error"
                            className="font-mono text-[12px] text-red-400"
                        >
                            {error}
                        </div>
                    )}
                    <button
                        data-testid="login-submit"
                        type="submit"
                        disabled={submitting}
                        className="w-full group relative overflow-hidden border border-white/80 hover:border-[#FFE600] px-6 py-3 font-mono text-[11px] tracking-[0.3em] uppercase disabled:opacity-50"
                    >
                        <span className="relative z-10 group-hover:text-black transition-colors">
                            {submitting ? "Signing in…" : "Sign in →"}
                        </span>
                        <span className="absolute inset-0 bg-[#FFE600] scale-x-0 group-hover:scale-x-100 origin-left transition-transform duration-500" />
                    </button>
                </div>
            </form>
        </div>
    );
}
